import { useCallback, useMemo } from 'react';

import { MATCH_PATTERN } from '../../configurations/number/number';

type formatterFunction = (value: string) => string;

export function useNumberFormatter({
  maximumFractionDigits,
  minimumFractionDigits,
}: Intl.NumberFormatOptions): formatterFunction {
  const formatter = useMemo(
    () => new Intl.NumberFormat('de-IN', { maximumFractionDigits, minimumFractionDigits }),
    [maximumFractionDigits, minimumFractionDigits]
  );

  return useCallback<formatterFunction>(
    (value: string) => {
      const match = MATCH_PATTERN.exec(value);

      if (!match) {
        return value;
      }

      const { groups, fraction } = match.groups;

      const number =
        parseInt(groups.replace(/[^\d]/gi, ''), 10) + (parseInt((fraction || '').padEnd(2, '0'), 10) || 0) / 100;

      return formatter.format(number);
    },
    [formatter]
  );
}
